module.exports = __webpack_public_path__ + "img/z2.b84e0591.png";